export const nomagoCompanyId = "808"
export const samoborcekCompanyId = "377"